@import '@hevoio/hevo-ui-toolkit/styles/variables';

.drawerPaper {
  background: $surface-bg !important;
}
